module.exports = __webpack_public_path__ + "img/ceo.cae05ce4.png";